export default {
  get_viewport(){
    var e = window, a = 'inner';
    if (!('innerWidth' in window )) {
      a = 'client';
      e = document.documentElement || document.body;
    }
    return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
  },
  scrollTo2(element, duration){
    var startingY = window.pageYOffset
    var diff = window.pageYOffset + element.getBoundingClientRect().top - startingY  
    var start
    window.requestAnimationFrame(function step(timestamp) {
      if (!start) start = timestamp
      var time = timestamp - start
      var percent = Math.min(time / duration, 1)
      window.scrollTo(0, startingY + diff * percent)
      if (time < duration) {
        window.requestAnimationFrame(step)
      }
    })  
  },
  isTouch() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  },
  loadScript(src,id){
    return new Promise( (resolve, reject) => {
      if(!document.querySelector('script#'+id) ){
        var s;
        s = document.createElement('script');
        s.id = id
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      } else { resolve() }
    });
  },
  handleArrow(event){
    event.preventDefault()
    var nextIndex = parseInt(event.target.dataset.index) + 1
    var next = document.querySelectorAll('[data-type="layout"]')[parseInt(event.target.dataset.index)]
    
    var scrollBottom = (element,duration) =>{
      var startingY = window.pageYOffset
      var diff = element.getBoundingClientRect().bottom
      var start
      window.requestAnimationFrame(function step(timestamp) {
        if (!start) start = timestamp
        var time = timestamp - start
        var percent = Math.min(time / duration, 1)
        window.scrollTo(0, startingY + diff * percent)
        if (time < duration) {
          window.requestAnimationFrame(step)
        }
      })  
    }

    scrollBottom(next,450)
  },
  addArrows(){
    document.querySelectorAll('[data-type="layout"] .read-more').forEach( item => {
      item.addEventListener('click', this.handleArrow, true)
    })
  },
  removeArrows(){
    document.querySelectorAll('[data-type="layout"] .read-more').forEach( item => {
      item.removeEventListener('click', this.handleArrow, true)
    })
  }
}


// WEBPACK FOOTER //
// ./src/js/scripts.js